import type { SecondaryOrderStatePath } from 'state/secondaryMarket/secondaryMarket.model';
import type { OrderActionType } from 'state/secondaryMarket/shared/actions';
import { secondaryMarketKycActionsFactory } from 'state/secondaryMarket/shared/kyc/kyc.action';
import { secondaryMarketSelectorsFactory } from 'state/secondaryMarket/shared/selector';
import type { Thunk } from 'state/state.common';

export function secondaryMarketKycStatusThunksFactory(
  statePath: Exclude<SecondaryOrderStatePath, 'cpOrder'>,
  orderAction: OrderActionType,
) {
  const secondaryMarketSelectors = secondaryMarketSelectorsFactory(statePath, {});
  const kycActions = secondaryMarketKycActionsFactory(orderAction);
  const secondaryMarketKycStatusRequestedThunk = (tabId: string): Thunk<void> => {
    return (dispatch, getState) => {
      const state = getState();
      const client = secondaryMarketSelectors.getFormClient(state, tabId);
      const salesId = secondaryMarketSelectors.getFormSalesId(state, tabId);
      const salesCountry = secondaryMarketSelectors.getFormCountryId(state, tabId, salesId)!;

      const clientBdrId = client?.id;

      if (clientBdrId !== undefined && salesCountry !== undefined) {
        dispatch(kycActions.secondaryMarketKycStatusRequested(tabId, clientBdrId, salesCountry));
      }
    };
  };

  return { secondaryMarketKycStatusRequestedThunk };
}
